import classnames from 'classnames';
import { useState } from 'react';

import { clickLPFAQItem } from '@/utils/analytics/log-event';

import { LandingPageProps } from '..';

type QuestionProps = {
  questionItem: QuestionItem;
};

type QuestionItem = {
  question: string;
  answer: string | JSX.Element;
  description: string;
};

const Question: React.FC<QuestionProps> = ({ questionItem }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  return (
    <>
      <div className="border border-black">
        <div
          className="flex h-20 w-full cursor-pointer items-center justify-between p-5"
          onClick={() => {
            setShowAnswer(!showAnswer);
            if (!showAnswer) {
              clickLPFAQItem(questionItem.description);
            }
          }}
        >
          <div className="flex items-center">
            <div className="h-full text-[28px] font-semibold text-gray-700">
              Q:
            </div>
            <div className="ml-2 h-full pt-2 text-xs font-bold md:text-sm">
              {questionItem.question}
            </div>
          </div>
          <div className="text-xl font-bold">
            {showAnswer ? <>&minus;</> : <>&#43;</>}
          </div>
        </div>
        <div
          className={classnames(
            'w-full border-t border-black p-5 text-xs leading-relaxed',
            showAnswer ? 'block' : 'hidden',
          )}
        >
          {questionItem.answer}
        </div>
      </div>
    </>
  );
};

type Props = {
  lpProps: LandingPageProps;
};

const Component: React.FC<Props> = ({ lpProps }) => {
  const questionItems: QuestionItem[] = [
    {
      question: '動画で卓球のレベルは上達しますか？',
      answer: (
        <div>
          Shakehandsでは、複数の角度からの撮影やスロー再生での解説を取り入れており、見て理解・実践ができるような構成になっています。
          <br />
          1つの技につき1つの動画になっているので、着実に習得・練習が可能です。
        </div>
      ),
      description: 'can_i_improve',
    },
    {
      question: 'どんなジャンルの動画がありますか？',
      answer: (
        <div>
          フォアやバックハンド、ツッツキなどの初歩的な技術から、さまざまな戦型の練習法・対策まで
          {lpProps.totalVideos}本以上の動画をご用意しています。
          <br />
          初級者から上級者まで活用していただける動画を取り揃えています。
        </div>
      ),
      description: 'video_genres',
    },
    {
      question: '支払い方法は何がありますか？',
      answer: (
        <div>
          <div>
            クレジットカード支払い、銀行振り込みからお選びいただけます。
            <br />
            <br />
            <span className="font-bold">クレジットカード</span>
            <br />
            JCB / MASTER / VISA / AMEX /
            Dinersクレジットカードがご利用可能です。お支払い回数は1回のみとなります。
            <br />
            <br />
            <span className="font-bold">銀行振り込み</span>
            <br />
            銀行振込でのお支払いの場合、ご契約は6ヶ月単位となります。
          </div>
          <div className="my-3 flex gap-x-3">
            <div className="flex basis-1/2 flex-col items-center border border-black bg-[#F5F6FF] p-3 text-center">
              <div className="mb-1 text-sm font-bold">6ヶ月分</div>
              <div className="text-base font-bold">
                {lpProps.priceWithBankTransfer.halfYear}円（税込）
              </div>
              <div className="text-[10px]">
                （月額{lpProps.price}円 × 6ヶ月 + 消費税）
              </div>
            </div>
            <div className="flex basis-1/2 flex-col items-center border border-black bg-[#F5F6FF] p-3 text-center">
              <div className="mb-1 text-sm font-bold">12ヶ月分</div>
              <div className="text-base font-bold">
                {lpProps.priceWithBankTransfer.year}円（税込）
              </div>
              <div className="text-[10px]">
                （月額{lpProps.price}円 × 12ヶ月 × 10%OFF + 消費税）
              </div>
            </div>
          </div>
          会員登録後、支払い方法を選択いただきます。
        </div>
      ),
      description: 'payment_methods',
    },
    {
      question: '解約はすぐにできますか？',
      answer:
        'マイページの一番下の［サービス解除・退会手続き］ボタンよりいつでも解約できます。',
      description: 'how_to_cancel',
    },
  ];

  return (
    <div className="mt-4 flex w-full flex-col gap-y-2 px-2 md:w-[620px]">
      {questionItems.map(item => (
        <Question key={item.question} questionItem={item} />
      ))}
    </div>
  );
};

export default Component;
